import { atom } from "jotai";
import { getSessionItem, setSessionItem } from "@/utils/storage";

export const createSessionAtom = (storageKey, initialValue = null) => {
    const baseAtom = atom(getSessionItem(storageKey) ?? initialValue);

    return atom(
        (get) => get(baseAtom),
        (get, set, value) => {
            set(baseAtom, value);
            setSessionItem(storageKey, value);
        }
    );
};
